import Option from '@/components/form/types/Option.ts';
import { Territory } from '@/features/dashboard/tfg/types/Territory.ts';

export const territoryLabels: Record<Territory, string> = {
  [Territory.POLAND_AND_NEIGHBORS]: 'Polska i kraje sąsiednie',
  [Territory.EUROPEAN]: 'Europejskie',
  [Territory.NON_EUROPEAN]: 'Pozaeuropejskie',
};

export const getTerritoryLabel = (territory: string): string =>
  territoryLabels[territory as Territory] ?? territory;

export const territorySelectOptions: Option[] = Object.values(Territory).map(
  (value) => ({
    value,
    label: territoryLabels[value],
  }),
);
